import React, { Fragment, useEffect } from 'react';
import { Box, Grid, Container, useMediaQuery } from '@mui/material';
import { inject, observer } from 'mobx-react';
import { compose } from 'utils/compose';

import withMediaQuery from 'constants/mediaQuery';
import Map from 'components/TrackingCode/Map';
import Event from 'components/TrackingCode/Event';
import Progress from 'components/TrackingCode/Progress';
import ShipmentInfo from '../Shipment';
import ManageDelivery from 'components/TrackingCode/ManageDelivery';
import ManageDeliveryLiteLink from 'components/TrackingCode/ManageDeliveryLiteLink';
import NoTouchDelivery from 'components/TrackingCode/NoTouchDelivery';
import MainDialog from '../Dialog';
import Footer from 'components/Footer';
import DialogStepOne from '../Dialog/DialogStepOne';
import DialogStepTwo from '../Dialog/DialogStepTwo';

import { useStyles } from '../styles';

function CustomProfile(props) {
  const classes = useStyles();
  const {
    store,
    mediaQuery,
    signRequired,
    client,
    client_profile,
    shipment,
    progress,
    isDelivered,
    milestone,
    translatedEvents,
    courier,
    delivery,
    settings,
    trackingCode,
    editedDeliveryData,
    dialogStep,
    dialogOpened,
    dialogLoading,
    podStore,
    history,
    closeDialog,
  } = props;

  const { currentStep } = podStore;
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down('sm'));
  const isVerificationStep = isMobile && [1, 2].includes(currentStep);

  useEffect(() => {
    // On mobile the verification steps replace the page content inline, so reset the scroll position to show the dialog from the top.
    // <body> is the scroll container (html has overflow: hidden in font-face.css), so window.scrollTo alone does nothing.
    if (!isVerificationStep) return;
    document.body.scrollTop = 0;
    window.scrollTo(0, 0);
  }, [isVerificationStep, currentStep]);

  const handleNext = (v) => {
    podStore.updateCurrentStep(v);
  };

  const handleCancel = () => {
    podStore.cancelVerification();
  };

  const handleGetPOD = () => {
    podStore.completeVerification();
  };

  return (
    <Container maxWidth={false} disableGutters sx={classes.container}>
      {((isMobile && ![1, 2].includes(currentStep)) || !isMobile) && (
        <Fragment>
          {signRequired && settings && <NoTouchDelivery classes={classes} />}
          <Container sx={classes.bodyContainer}>
            <Box mb={mediaQuery.isMobile ? 2 : 3} sx={classes.boxWrapper}>
              <Progress mediaQuery={mediaQuery} classes={classes} shipment={shipment} progress={progress} milestone={milestone} />
              <ShipmentInfo
                store={store}
                client={client}
                client_profile={client_profile}
                classes={classes}
                mediaQuery={mediaQuery}
                settings={settings}
                courier={courier}
                shipment={shipment}
                milestone={milestone}
                isDelivered={isDelivered}
                trackingCode={trackingCode}
                translatedEvents={translatedEvents}
                editedDeliveryData={editedDeliveryData}
                delivery={delivery}
              />
            </Box>

            {!isDelivered && <ManageDelivery classes={classes} store={store} mediaQuery={mediaQuery} trackingCode={trackingCode} />}
            <ManageDeliveryLiteLink store={store} trackingCode={trackingCode} isDelivered={isDelivered} />

            <Box mb={4}>
              <Grid container spacing={mediaQuery.isMobile ? 0 : 2} sx={classes.eventsAndMap}>
                <Map mediaQuery={mediaQuery} classes={classes} milestone={milestone} />
                <Event
                  classes={classes}
                  delivery={delivery}
                  translatedEvents={translatedEvents}
                  podStore={podStore}
                  history={history}
                  closeDialog={closeDialog}
                />
              </Grid>
            </Box>
            {/* <FAQ /> */}
          </Container>
        </Fragment>
      )}

      {isMobile && currentStep === 1 && <DialogStepOne handleClose={handleCancel} handleNext={(v) => handleNext(v)} closeDialog={closeDialog} />}
      {isMobile && currentStep === 2 && <DialogStepTwo handleClose={handleCancel} handleNext={(v) => handleGetPOD(v)} closeDialog={closeDialog} />}
      {(!settings?.hide_footer || settings.hide_footer === 'false') && <Footer settings={settings} client={client} />}

      <MainDialog
        store={store}
        classes={classes}
        mediaQuery={mediaQuery}
        step={dialogStep}
        open={dialogOpened}
        loading={dialogLoading}
        closeDialog={closeDialog}
      />
    </Container>
  );
}
const CustomProfileCompose = compose(inject('store'), observer)(CustomProfile);

export default withMediaQuery()(CustomProfileCompose);
